
    import Vue from "vue";
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";
    import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";
    import {QualificationViewModel, SpecialityType, ApplicationSortField} from "@/api-client";
    import {formatDate} from "@/formatting/dateFormatter";
    import ClientsidePaging from "@/components/ClientsidePaging";
    import {BvTableFieldArray} from "bootstrap-vue";
    import ValidityStatusBadge from "@/features/shared/components/ValidityStatusBadge.vue";
    import ClientsidePagingSelector from "@/components/ClientsidePagingSelector.vue";

    @Component({
        components: {
            ValidityStatusBadge,
            TableEmptySlot,
            ClientsidePagingSelector
        }
    })
    export default class QualificationTable extends Vue {
        @Prop({ required: true})
        qualifications!: QualificationViewModel[];
        @Prop({ default: false})
        withPagination!: boolean;

        paging = new ClientsidePaging();
                
        navigateToDetails(qualification: QualificationViewModel) {
            const routeMap: { [id: string]: string; } = {};
            routeMap[SpecialityType.Educational] = "educational-details";
            routeMap[SpecialityType.Training] = "training-details";
            this.$router.push({name: routeMap[qualification.specialityType], params: {id: qualification.id}});
        }
        
        // Note 'isActive' is left out and will not appear in the rendered table
        fields: BvTableFieldArray = [
            { key: 'speciality', label: this.$ls.Global_Label_Speciality, sortable: true, thClass: 'w-20'},
            { key: 'specialityType', label: this.$ls.Documents_Qualifications_Table_Label_SpecialityType, sortable: true, sortByFormatted: true,
                formatter: (value: any, key: any, item: QualificationViewModel) => {
                    return item.specialityType == SpecialityType.Training
                        ? this.$ls.Documents_Qualifications_SpecialityType_TrainingCourses
                        : this.$ls.Documents_Qualifications_SpecialityType_FormalEducation;
                }
            },
            { key: 'issuedOn', label: this.$ls.Global_Label_IssueDateShort, sortable: true,
                formatter: (value: any, key: any, item: QualificationViewModel) => formatDate(item.issuedOn, "-") },
            { key: 'validUntil', label: this.$ls.Global_Label_ValidUntil, sortable: true,
                formatter: (value: any, key: any, item: QualificationViewModel) => formatDate(item.validUntil, "-") },
            { key: 'additionalInformation', label: this.$ls.Global_Label_AdditionalInfo, sortable: true, thClass: 'w-20',
                formatter: (value: any, key: any, item: QualificationViewModel) => item.additionalInformation },
            { key: 'validity', label: this.$ls.Global_Label_DocumentState, sortable: true, thClass: 'w-10',
                formatter: (value: any, key: any, item: QualificationViewModel) => { return item.validity }},
            { key: 'linkIcon', label: '', sortable: false, thClass: 'w-5', tdClass: 'table-actions' }
        ];
        
    }
